export default __webpack_public_path__ + "static/media/LOADING2.36a44067.gif";